// extracted by mini-css-extract-plugin
export var container = "styles-module__container___hsGh5";
export var couponCard = "styles-module__couponCard___knoOV";
export var searchButtons = "styles-module__searchButtons___CM_D3";
export var searchBox = "styles-module__searchBox___ICIQY";
export var msgDisplay = "styles-module__msgDisplay___pn3Uz";
export var couponBoxContainer = "styles-module__couponBoxContainer___OSOQV";
export var expireBtn = "styles-module__expireBtn___E0a0b";
export var inputEditContainer = "styles-module__inputEditContainer___yFwoe";